export const checkoutUrl = 'https://prof-d-espagnol-pret.impultienda.ar/checkout'
export const productName = "Prof d'Espagnol Prêt"
export const priceToday = '27 €'
export const priceRegular = '105 €'
export const ctaLabel = '🟡 OBTENIR LE SYSTÈME COMPLET MAINTENANT'
